import SectionTitle from 'components/SectionTitle';
import IntlMessages from 'util/IntlMessages';

const ConnectorTitle = ({ connectorName }: { connectorName: string | null | undefined }) => {
  return (
    <SectionTitle
      title={
        <span>
          <IntlMessages id="common.labels.connector" />
          <span data-testid="connector-drawer-title">{` ${connectorName}`}</span>
        </span>
      }
    />
  );
};

export default ConnectorTitle;
